import { Container, Eyebrow, LandingButton, SIGN_UP_PATH } from "./primitives";
import { useOpenContact } from "./ContactModal";

export function CtaSection() {
  const openContact = useOpenContact();
  return (
    <section className="bg-[#120240] bg-[radial-gradient(ellipse_45%_60%_at_50%_42%,rgba(228,0,43,0.13)_0%,rgba(18,2,64,0)_70%)] py-24 lg:py-[128px]">
      <Container className="flex flex-col items-center text-center">
        <Eyebrow tone="white">Get started today</Eyebrow>
        <h2 className="!mt-4 text-[40px] font-extrabold leading-[1.07] tracking-[-0.045em] text-[#F18095] md:text-[52px] lg:text-[58px]">
          Take control of your
          <br />
          health records today.
        </h2>
        <p className="!mt-[22px] max-w-[680px] text-[18px] leading-[30px] text-white">
          Join thousands of patients who finally understand their own health in one place, from any
          hospital, in any format.
        </p>
        <div className="mt-9 flex flex-wrap justify-center gap-3.5">
          <LandingButton
            to={SIGN_UP_PATH}
            className="!h-[54px] !px-8 !text-[16px] !shadow-[0_8px_28px_rgba(241,128,149,0.45)]"
          >
            Get Started Free
          </LandingButton>
          <LandingButton variant="outline-light" onClick={() => openContact("demo")} className="!h-[54px] !px-8 !text-[16px]">
            Book a Demo
          </LandingButton>
        </div>
        <p className="!mt-[22px] text-[13px] text-white/85">No credit card required · HIPAA-compliant · Cancel anytime</p>
      </Container>
    </section>
  );
}
